import { render } from "./ReportEquipment.vue?vue&type=template&id=71e23d1c"
import script from "./ReportEquipment.vue?vue&type=script&lang=js"
export * from "./ReportEquipment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportEquipment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71e23d1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71e23d1c', __exports__)) {
    console.log('reload')
    api.reload('71e23d1c', __exports__)
  }
  
  module.hot.accept("./ReportEquipment.vue?vue&type=template&id=71e23d1c", () => {
    console.log('re-render')
    api.rerender('71e23d1c', render)
  })

}


export default __exports__